export class ClaimPermissions {
    static readonly type = '[User] ClaimPermissions';

    constructor(public payload: string) {}
}
